// Centralized specialty slugs - used by Nav dropdown and Symptoms cards
// When dedicated pages are created, routes /especialidades/:slug will work automatically.
export const SPECIALTIES = [
  { slug: "distonia", label: "Distonia" },
  { slug: "espasticidade", label: "Espasticidade" },
  { slug: "enxaqueca", label: "Enxaqueca" },
];

export const specialtyHref = (slug) => `/especialidades/${slug}`;
